import qs from 'qs'
import { CreateExpenseDto, ExpenseFilter } from '../models'
import axiosClient from './axiosClient'

const PATH = '/expenses'

export const expenseApi = {
  getExpenses: (filter: ExpenseFilter) =>
    axiosClient.get(PATH, {
      params: filter,
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'repeat' }),
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),

  getExpenseById: (id: number) =>
    axiosClient.get(`${PATH}/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),

  createExpense: (createExpenseDto: CreateExpenseDto) =>
    axiosClient.post(PATH, createExpenseDto, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),
}
